export default __webpack_public_path__ + "adfa5bec891720c3e2c3e32c9e639572.jpg";